//constants
import SampleCons from "../../constants/sample";

//contexts
import { useSampleContext } from "../../contexts";

export default function SampleInformation({ sample }) {
  //contexts
  const { getLabel } = useSampleContext();

  return (
    <div className=' my-2 full-height'>
      <div className='card full-height'>
        <div className='card-body'>
          <h5 className='card-title text-primary'>Sample Information</h5>
          <div className=' d-flex justify-content-between flex-wrap pe-2'>
            <div className='px-1'>
              <h6>Sample ID:</h6>
              <p className='mb-0'>{sample.sampleId}</p>
            </div>
            <div className='px-1'>
              <h6>Food Matrix:</h6>
              <p className='mb-0'>
                {getLabel(sample.foodMatrix, SampleCons.FOOD_MATRIX) ||
                  sample.foodMatrix}
              </p>
            </div>
            <div className='px-1'>
              <h6>Analyte:</h6>
              <p className='mb-0'>
                {getLabel(sample.analyte, SampleCons.ANALYTE) || sample.analyte}
              </p>
            </div>
            <div className='px-1'>
              <h6>Extraction Solvent:</h6>
              <p className='mb-0'>
                {getLabel(
                  sample.extractionSolvent,
                  SampleCons.EXTRACTION_SOLVENT
                ) || sample.extractionSolvent}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
